module.exports = __webpack_public_path__ + "img/coverBanner-ar.32566834.jpg";